export const channelCounts = {
  2: "Stereo",
  4: "Quad",
  6: "5.1",
};
